const {Component, PureComponent} = require("react");
const PropTypes = require("prop-types");
const moment = require("moment");
const BaseList = require("app/components/lists/List");
const LazyImg = require("app/components/mixins/LazyImg");

class PostListItem extends PureComponent {

	static get propTypes() {
		return {
			category_name: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
            thumbnail_url: PropTypes.string.isRequired,
            published_at: PropTypes.string.isRequired,
			displayDate: PropTypes.bool,
			url: PropTypes.string,
		};
	}

	static get defaultProps() {
		return {
			displayDate: true,
			url: "#"
		}
	}

	get dateHtml() {
		if (this.props.displayDate) {
			return (
				<div className="date">{moment(this.props.published_at, "YYYY-MM-DD").format("D. MMM, YYYY")}</div>
			);
		}
	}

	render() {
		return (
			<div className="post">
				<a href={this.props.url}>
					<div className="object-fit thumbnail">
						<LazyImg className='thumbnail' distance={290} src={this.props.thumbnail_url} name={this.props.title}/>
					</div>
					<div className="details">
						<div className="details-inner">
							<div className="details-center">
								<div className="category">{this.props.category_name}</div>
								<div className="title">{this.props.title}</div>
								{this.dateHtml}
							</div>
						</div>
					</div>
				</a>
			</div>
		);
	}
}

class PostList extends BaseList {

	static get propTypes() {
		return {
			items: PropTypes.array,
			displayDate: PropTypes.bool
		};
	}

	static get defaultProps() {
		return {
			items: [],
			displayDate: true
		};
	}

	get className() {
		return "post-list";
	}

	renderItem(item) {
		return (
			<PostListItem key={item.id} {...item} displayDate={this.props.displayDate}/>
		);
	}
}

module.exports = PostList;